const swapItems = document.querySelectorAll('[data-swap]');

swapItems.forEach((swapItem)=>{

    //get the data ids of the items to hide and show
    const hideElementID = swapItem.dataset.swapHide;
    const showElementID = swapItem.dataset.swapShow;

    swapItem.addEventListener('click', (event) => {
        
        //
        event.preventDefault();

        //
        const hideElement = document.querySelector('[data-swap-id="' + hideElementID + '"]');
        const showElement = document.querySelector('[data-swap-id="' + showElementID + '"]');

        //
        hideElement.style.display = 'none';
        showElement.style.display = (showElement?.dataset?.swapDisplay ?? 'block');

    });

});
